(function() {
	'use strict';

	var $ = avm.require('jquery');
	$("[id$='-content1']").removeClass("show");
	$("[id$='-content1']").removeClass("active");

	$('.view-all-features').on("click",function() {
		$("[id$='-content1']").removeClass("show");
		$("[id$='-content1']").removeClass("active");
		$(".js-open-comparison").trigger("click");
	});

	$('.js-open-comparison').on("click", function() {
		$("[id$='-tab1']").trigger("click");
		$("[id$='-content1']").addClass("show");
		$("[id$='-content1']").addClass("active");
	});
	$('.js-close-comparison').on("click", function() {
		$("[id$='-content1']").removeClass("show");
		$("[id$='-content1']").removeClass("active");
		$("[id$='-content2']").removeClass("show");
		$("[id$='-content2']").removeClass("active");
		$("[id$='-content3']").removeClass("show");
		$("[id$='-content3']").removeClass("active");
		$("[id$='-content4']").removeClass("show");
		$("[id$='-content4']").removeClass("active");
	});
})();
